import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddAssessment.module.css";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="6.1"
          title="Procedure and/or Process for Internal Audits"
          questions={[
            {
              content:
                "Has the laboratory defined a procedure and/or process that addresses, but is not limited to, the following?",
              hideOptions: true,
            },
            {
              content:
                "Inputs into planning, scheduling, and conduct of internal audits;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Scheduling of internal audits;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Frequency of internal audits;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Scope of internal audits;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Criteria for internal audits;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Selection of internal auditors;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Recording of audit findings;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Addressing identified nonconformities;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Advice on required sample types and volumes for testing.",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Monitoring of the effectiveness of corrective actions.",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="6.2"
          title="Internal Audits"
          questions={[
            {
              content: (
                <>
                  Are internal audits conducted at intervals as defined in the
                  internal audit program and do these audits address all areas
                  of the laboratory management systems?
                  <br />
                  Is there an audit program that ensures all activities of the
                  laboratory are audited?
                </>
              ),
              hideOptions: true,
            },
            {
              content:
                "Are audits being carried out with minimal conflict of interest where possible, carried out by persons who are not involved in activities in the section being audited?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are the personnel conducting the internal audits trained, qualified, and authorized to conduct internal audits?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are internal audit findings documented and presented to laboratory management and relevant personnel for review?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="6.3"
          title="Audit Recommendations and Action Plan and Follow-up"
          questions={[
            {
              content:
                "Are internal audits reports generated, disseminated, and communicated to laboratory management and relevant personnel for review?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Is an action plan developed with clear timelines, assigned personnel and documented follow-up within the timeframe defined by laboratory management?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are recommendations for improvement actions made based on audit findings?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="6.4"
          title="Procedure and/or Process for Risk Management"
          questions={[
            {
              content: (
                <>
                  Has the laboratory defined a procedure and/or process that
                  addresses, but is not limited to, the following?
                  <br />
                  Note: Risk must be managed at the pre-examination processes,
                  examination processes and post-examination processes. The
                  laboratory shall evaluate the impact of work processes and
                  potential failures on examination results as they affect
                  patient safety and shall modify processes to reduce or
                  eliminate the identified risks and document decisions and
                  actions taken. Risk management must take into consideration
                  patient care and laboratory activities
                </>
              ),
              hideOptions: true,
            },
            {
              content: "Methods used to identify risks and opportunities;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Areas for identifying risks and opportunities associated with its examinations and activities;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Development of action plans to address both risks and opportunities for improvement;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Evaluation of the effectiveness of implemented actions and modification where required;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Recording and communication of decisions made, and actions taken on risks and opportunities",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="6.5"
          title="Risk Management"
          questions={[
            {
              content:
                "Has laboratory management developed and implemented a risk management program that identifies risks and opportunities for improvement in all laboratory processes including but not limited to:",
              hideOptions: true,
            },
            {
              content: "Impartiality;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Confidentiality;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Structural and governance requirements;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Personnel;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Facilities and environmental activities;",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Equipment;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Reagents and consumables;",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Service agreements;",
              number: "h",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Externally provided products and services",
              number: "i",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Pre-examination processes;",
              number: "j",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Examination processes (including POCT);",
              number: "k",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Post-examination processes;",
              number: "l",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Nonconforming work;",
              number: "m",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Control of data and information management;",
              number: "n",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Complaints;",
              number: "o",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Management system documentation;",
              number: "p",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Control of management system documents;",
              number: "q",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Control of records;",
              number: "r",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Nonconformities and corrective actions;",
              number: "s",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Evaluations;",
              number: "t",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Management review",
              number: "u",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="6.6"
          title="Risk Management Assessment"
          questions={[
            {
              content:
                "Does the laboratory use evaluation tools to identify risks and opportunities for improvements?",
              hideOptions: true,
            },
            {
              content: "Internal audits;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Customer complaints/feedback;",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Nonconforming event management;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Management review;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content: "Quality indicators",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
        <QuestionSection
          number="6.7"
          title="Risk and Opportunities Action Plan"
          questions={[
            {
              content:
                "Is an action plan for identified risks and opportunities for improvement developed and implemented with clear timelines and responsibilities?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Does laboratory management evaluate the effectiveness of the risk and/or opportunities for improvement action plan?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are actions modified when actions are identified as being ineffective?",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="6.8"
          title="Quality Indicators"
          questions={[
            {
              content: (
                <>
                  Are quality indicators selected to cover pre-examination,
                  examination, and post-examination processes (e.g., turnaround
                  times, rejected samples, stock-outs, etc.), defined, measured,
                  and monitored?
                  <br />
                  Note 1: The identification of the quality indicators should
                  include establishing the objectives, methodology,
                  interpretation, limits, action plan and duration of monitoring
                  <br />
                  Note 2: The laboratory should select quality indicators in
                  line with meeting its objectives from pre-analytic, analytic,
                  and post-analytic phases critical to patient outcomes
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="6.9"
          title="Monitoring of Quality Indicators"
          questions={[
            {
              content: (
                <>
                  Are the outcome of the review of quality indicators used to
                  improve laboratory processes?
                  <br />
                  Note: The laboratory should review the quality indicators at
                  defined intervals
                </>
              ),
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddAssessment = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

  // --- Prefill answers if editing ---
  useEffect(() => {
    const fetchQuestionnaire = async () => {
      if (!questionnaireId) return; // new form
      try {
        setLoading(true);
        const response = await fetch(
          `${env.kataApiUrl}/api/certification/id/${questionnaireId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to load questionnaire");
        }

        const data = await response.json();

        console.log("DATATAA", data);

        setStatus(data.status);

        const prefilled = {};
        if (data.answers && Array.isArray(data.answers)) {
          data.answers.forEach((ans) => {
            prefilled[ans.questionNumber] = {
              score: ans.score,
              comment: ans.comment,
              points: ans.points,
            };
          });
        }

        setAnswers(prefilled);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestionnaire();
  }, [questionnaireId, token]);

  const handleAnswerChange = (questionNumber, score, comment, points) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionNumber]: {
        score,
        comment,
        points: points ? Number(points) : undefined,
      },
    }));
  };

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  const submitAssessment = async () => {
    const answersArray = Object.entries(answers).map(
      ([questionNumber, data]) => ({
        questionNumber,
        score: data.score,
        comment: data.comment,
        points: data.points,
      })
    );

    const payload = {
      name: "SLIPTA",
      labId,
      section: "Assessment",
      auditorId: user.id,
      answers: answersArray,
    };

    const url = questionnaireId
      ? `${env.kataApiUrl}/api/certification/id/${questionnaireId}` // edit
      : `${env.kataApiUrl}/api/certification/submit`; // create

    const method = questionnaireId ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Submission failed");
    }

    return await response.json();
  };

  const handleDone = async () => {
    try {
      if (Object.keys(answers).length === 0) {
        toast.warning("Please answer at least one question before submitting");
        return;
      }

      await submitAssessment();

      toast.success(
        questionnaireId ? "updated successfully!" : "Submitted successfully!"
      );

      navigate(-1);
    } catch (error) {
      toast.error(error.message || "Failed to submit assessment");
    }
  };

  return (
    <div
      className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">Section 06: Assessment {questionnaireId && "(Editing)"}</h2>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(handleAnswerChange, answers, editable)}

          {editable && (
            <CommonFooter
              handlePrevious={handlePrevious}
              handleCancel={() => navigate(-1)}
              handleNext={handleNext}
              handleDone={handleDone}
              questionSets={questionSets}
              currentSet={currentSet}
              cancelText="Cancel"
              doneText={
                questionnaireId ? "Update Assessment" : "Submit Assessment"
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default AddAssessment;
